export default function SvgShare() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        cursor="pointer"
        viewBox="0 0 32 32"
      >
        <path
          d="M29.28 12.47L18.6 3.62a2 2 0 00-2.17-.27 2 2 0 00-1.15 1.81v2A19.82 19.82 0 002 25.94a19.18 19.18 0 00.25 3.11 1 1 0 00.82.83h.17a1 1 0 00.88-.53 17.29 17.29 0 0111.16-8.68v2.16a2 2 0 001.15 1.81 2.09 2.09 0 00.88.2 2 2 0 001.29-.48l4.86-4 .09-.07 5.73-4.75a2 2 0 000-3.06zm-6.93 6.2l-.09.07-5 4.1v-3.42a.19.19 0 000-.08v-.09c0-.03 0-.07-.05-.11a1.34 1.34 0 00-.07-.18.57.57 0 00-.14-.16.49.49 0 00-.12-.13 1 1 0 00-.17-.12l-.15-.07h-.49A19.19 19.19 0 004 25.85a17.81 17.81 0 0112.56-17h.05a1.11 1.11 0 00.19-.09 1.43 1.43 0 00.2-.13l.12-.14a.54.54 0 00.1-.16.85.85 0 00.06-.17 1.3 1.3 0 000-.21V5.21L28 14z"
          data-name="Layer 2"
        ></path>
      </svg>
    </>
  );
}
